import { takeLatest, put, call } from 'redux-saga/effects'
import { camelizeKeys, decamelizeKeys, decamelize } from 'humps'
import _ from 'lodash'

import { requestGet } from 'containers/ReceptionCustom/api'
import {
  SettingTargets,
  defaultBerthColumnsPerPage,
  defaultReceptionNotificationSound,
} from 'constants/Settings'

const defaultValues = Object.freeze({
  [SettingTargets.BERTH_COLUMNS_PER_PAGE]: defaultBerthColumnsPerPage,
  [SettingTargets.RECEPTION_NOTIFICATION_SOUND]: defaultReceptionNotificationSound,
})

export function* fetchWarehouses({ payload }: any) {
  const { tenantId } = payload

  yield put({ type: 'base/START_LOADING' })

  try {
    // @ts-ignore TypeScript4系移行時に発生した型エラーを回避
    const resp = yield call(requestGet, '/warehouse/list_tenants_for_warehouse')

    // @ts-ignore TypeScript4系移行時に発生した型エラーを回避
    const camelizedWarehouses: any[] = camelizeKeys(resp.data) || []

    yield put({
      type: 'settings/FETCH_SUCCESS',
      payload: { storePath: 'warehouses', data: camelizedWarehouses },
    })

    // WHY: 保存済みの tenantId が一覧に無いことがある（テナント解約済み・倉庫の契約期間切れ・
    // user_tenants から外れた等）。undefined を参照すると saga が停止し、モジュール配下の
    // watcher ごと落ちて設定画面が操作不能になるため、テナントを持つ倉庫にフォールバックする。
    const matched: any = camelizedWarehouses.find((w: any) =>
      (w.tenants || []).some((tenant: any) => tenant.id === tenantId)
    )
    const warehouse: any =
      matched || camelizedWarehouses.find((w: any) => (w.tenants || []).length > 0)

    if (!warehouse) {
      yield put({
        type: 'settings/FETCH_SUCCESS',
        payload: { storePath: 'tenantFallback', data: false },
      })
      return
    }

    yield put({ type: 'settings/CHANGE_WAREHOUSE', payload: warehouse.id })

    // NOTE: ここまで来た warehouse は tenants が非空であることが保証されている
    const tenants = camelizeKeys(warehouse.tenants)
    yield put({ type: 'settings/FETCH_SUCCESS', payload: { storePath: 'tenants', data: tenants } })

    // NOTE: フォールバックした場合は保存済み tenantId を選択できないため先頭のテナントを選ぶ
    yield put({
      type: 'settings/CHANGE_TENANT',
      payload: matched ? tenantId : warehouse.tenants[0].id,
    })

    // WHY: フォールバックは保存時とは別の区分を選択した状態で画面を出すため、無言だと
    // 利用者が意図せず別の区分に対して設定を保存しうる。画面側で案内を出すためのフラグ。
    // NOTE: 毎回 !matched を入れるため、次に正常に開いたときは false に戻る
    yield put({
      type: 'settings/FETCH_SUCCESS',
      payload: { storePath: 'tenantFallback', data: !matched },
    })
  } catch (error) {
    // @ts-ignore TypeScript4系移行時に発生した型エラーを回避
    yield put({ type: 'OPEN_ERROR', payload: { message: error.message } })
  } finally {
    yield put({ type: 'base/STOP_LOADING' })
  }
}

function* fetchSettings({ payload }: any) {
  const { target, tenantId = 0, userId = 0 } = payload

  let resp: any

  yield put({ type: 'base/START_LOADING' })

  try {
    // @ts-ignore TypeScript4系移行時に発生した型エラーを回避
    resp = yield call(
      requestGet,
      '/berths/bookings/tenant_settings',
      decamelizeKeys({ target: decamelize(target), tenantId, userId })
    )
  } catch (error) {
    // @ts-ignore TypeScript4系移行時に発生した型エラーを回避
    yield put({ type: 'OPEN_ERROR', payload: { message: error.message } })
    return
  } finally {
    yield put({ type: 'base/STOP_LOADING' })
  }
  const displaySettingValue = _.get(resp, 'data.display_settings.value', null)
  // @ts-ignore TypeScript4系移行時に発生した型エラーを回避
  const data = displaySettingValue ? JSON.parse(displaySettingValue) : defaultValues[target]
  yield put({ type: 'settings/SAVE_SETTINGS', payload: { target, data } })
}

export default function* settingsSaga() {
  yield takeLatest('settings/FETCH_WAREHOUSES', fetchWarehouses)
  yield takeLatest('FETCH_SETTINGS', fetchSettings)
  yield takeLatest('settings/FETCH_SETTINGS', fetchSettings)
}
